import { render, staticRenderFns } from "./SoldItemByUser.vue?vue&type=template&id=f4248574&scoped=true"
import script from "./SoldItemByUser.vue?vue&type=script&lang=js"
export * from "./SoldItemByUser.vue?vue&type=script&lang=js"
import style0 from "./SoldItemByUser.vue?vue&type=style&index=0&id=f4248574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4248574",
  null
  
)

export default component.exports